import { useContext } from 'react';
import { SettingsContext } from '../contexts/settings_context';

const useSettings = () => useContext(SettingsContext);

export default useSettings;
